/**
 * useEnrollmentsByProject — fans `GET /projects/{pid}/enrollments` out across
 * every project id via `useQueries` (can't call `useProjectEnrollmentsQuery`
 * itself in a loop — hook count must stay static). Shares the same query key
 * as that hook (`factoryKeys.enrollments`), so it reads/writes the same
 * cache entry.
 *
 * Extracted (Task 11 review fold-in) from `AdminControlRoom.tsx` and
 * `InternalCategory.tsx`, which both defined this fan-out verbatim.
 */

import { useQueries } from "@tanstack/react-query";
import axios from "axios";

import { getApiBaseUrl } from "../../../config/api";
import { factoryKeys } from "../../../hooks/useFactoryQueries";
import type { Enrollment } from "../../../types/factory";

function factoryUrl(path: string): string {
  return `${getApiBaseUrl()}/api/labeling/factory${path}`;
}

export function useEnrollmentsByProject(projectIds: string[]) {
  return useQueries({
    queries: projectIds.map((pid) => ({
      queryKey: factoryKeys.enrollments(pid),
      queryFn: async () => {
        const response = await axios.get<Enrollment[]>(
          factoryUrl(`/projects/${encodeURIComponent(pid)}/enrollments`),
        );
        return response.data;
      },
      enabled: !!pid,
      retry: 2,
    })),
  });
}

export default useEnrollmentsByProject;
